// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-dropdown-link[data-v-67979744]{cursor:pointer;color:#409eff}.el-icon-arrow-down[data-v-67979744]{font-size:12px}", ""]);
// Exports
module.exports = exports;
